import ApiService from './../api/ApiService';
import Urls from './../api/Urls';
import Config from '../constants/Config';
import UploadResponse from '../models/UploadResponse';

export function uploadFile(formData) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.UPLOAD_STORAGE,
        parser: data => new UploadResponse(data.data),
    }).post(formData);
}
